var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company-strategy"},[_c('h2',{staticClass:"company-strategy__subtitle",domProps:{"innerHTML":_vm._s(_vm.text.subtitle)}}),_vm._v(" "),_c('div',{staticClass:"company-strategy__scheme",domProps:{"innerHTML":_vm._s(_vm.isVMobile() ? _vm.scheme.mobile : _vm.scheme.desktop)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }